import PregnancyView from './pregnancy-view'

export default PregnancyView
